import React, { Component } from 'react'
import { Input, Select, Spin, Table, Tooltip, Alert, Modal, Divider } from 'antd';
import { defaultDateFormat, showErrorInNotification, NetworkDelaySearch, formatMoney } from '../../lib/util';
import CustomDateRangePicker from '../../components/custom_date_range';
import moment from 'moment';
import FilterFixedInput from '../../components/filter_fixed_input';
import NetworkSelect from '../../lib/ui/network_select';
import { BasicHeader } from '../../components/basic_header';
import { RESTExecutor, withDomains } from '../../lib/domain';
import ErrorWrapper from '../../lib/error_wrapper';
import { COLORS } from '../theme';
import { Link } from 'react-router-dom';
import { TransparentButton } from '../../components/basic_items';
import { FlipOutlined, InsertDriveFileOutlined, LayersOutlined, WifiTetheringOutlined, MoreHorizOutlined, AssignmentReturn, PermIdentity, Computer, MenuOpenOutlined, PriorityHigh, CheckOutlined, MoreHoriz, More, MoreOutlined, SwapHoriz, StorageOutlined } from '@material-ui/icons';
import ModalPacketDetail from '../../components/modal_packet_detail';
import ExternalFilterClear from '../../components/external_filter_clear';


const queryString = require('query-string');

const packets_cols = ({ datatype, filters = {}, onViewclicked, onFilterUpdate }) => [
    {
        title: "Mode",
        dataIndex: 'transferred',
        key: 'mode',
        width: 40,
        render: (value, record) => {
            let label = value ?
                record.manual_transfer ? "M" : "A" :
                record.un_transferred == true ? "U" :
                    record.transferred == false ? "Q" :
                        ""


            let status = value;
            return <div
                className={status ? 'text-tag-success' : 'text-tag-danger'}
                style={{
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                {label}
            </div>
        }
    },
    // {
    //     title: "CREATED AT",
    //     dataIndex: 'created_at',
    //     key: 'created_at'
    // },
    {
        title: "SOURCE",
        dataIndex: 'source_id',
        key: 'source_id',
        render: (source_id) => <Link
            to={{
                pathname: `/activity/data-type/${datatype}/packets/forsource`,
                search: queryString.stringify({...filters,source_id:source_id})
            }}
        >{source_id}</Link>
    },
    {
        title: "FILE URI",
        dataIndex: 'file_uri',
        key: 'file_uri'
    },
    {
        title: "MIN TXN DATE",
        dataIndex: 'min_txn_date',
        key: 'min_txn_date'
    },
    {
        title: "MAX TXN DATE",
        dataIndex: 'max_txn_date',
        key: 'max_txn_date'
    },

    // {
    //     title: "TRANSFERRED",
    //     dataIndex: 'transferred',
    //     key: 'transferred',
    //     render: (transferred, record) => <div style={{
    //         display: 'flex',
    //         flexDirection: 'row',
    //         alignItems: 'center'
    //     }}><span style={{
    //         color: transferred ? COLORS.success_primary : COLORS.danger_primary,
    //         marginRight: 6
    //     }}>
    //             {transferred ? "YES" : "NO"}

    //         </span>
    //         {transferred && (record.manual_transfer == true ? <PermIdentity 
    //         className='hand-cursor'
    //         onClick={()=>{
    //             typeof onFilterUpdate==='function'&&onFilterUpdate({
    //                 transferred:'manual'
    //             })
    //         }}
    //         titleAccess="Manual Transfer" /> : <Computer 
    //         className='hand-cursor'
    //         onClick={()=>{
    //             typeof onFilterUpdate==='function'&&onFilterUpdate({
    //                 transferred:'automated'
    //             })
    //         }}
    //         titleAccess="Automated Transfer" />)}
    //     </div>
    // },
    {
        title: "Classifier",
        width: 100,
        key: 'Classifier',
        className: 'pipeline-cols center-align',
        render: (record) => {
            let success_count = record.classification_success;
            let error_count = record.classification_error;
            let obj = {
                children: <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {record.processed == false ?
                        error_count > 0 ? <Link to={{
                            pathname: `/activity/data-type/${record.data_type_id}/nottransferredtransactions`,
                            search: queryString.stringify({
                                dateFrom: record.min_txn_date,
                                dateTo: record.max_txn_date,
                                parse_batch_id: record.parse_batch_id,
                                source_id: record.source_id,
                                fetcher_response_id: record.fetcher_response_id,
                                error_type: 3
                            })
                        }}>
                            <span className='error-text'>{formatMoney(success_count, 0)} (-{formatMoney(error_count, 0)})</span>
                        </Link> :

                            <Link to={{
                                pathname: `/activity/data-type/${record.data_type_id}/nottransferredtransactions`,
                                search: queryString.stringify({
                                    dateFrom: record.min_txn_date,
                                    dateTo: record.max_txn_date,
                                    parse_batch_id: record.parse_batch_id,
                                    source_id: record.source_id,
                                    fetcher_response_id: record.fetcher_response_id,
                                    success_type: 3
                                })
                            }}>
                                <span className='right-align'>{formatMoney(success_count, 0)}</span>
                            </Link> :
                        <span className='right-align'>{formatMoney(success_count, 0)}</span>
                    }
                </div>,
                props: {
                    className: error_count > 0 ? 'pipeline-error-cell' : 'pipeline-success-cell'
                }
            }


            return obj;
        }
    },
    {
        title: "Extractor",
        width: 100,
        key: 'Extractor',
        className: 'pipeline-cols center-align',
        render: (record) => {
            let success_count = record.extraction_success;
            let error_count = record.extraction_error;
            let obj = {
                children: <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {record.processed == false ?
                        error_count > 0 ? <Link to={{
                            pathname: `/activity/data-type/${record.data_type_id}/nottransferredtransactions`,
                            search: queryString.stringify({
                                dateFrom: record.min_txn_date,
                                dateTo: record.max_txn_date,
                                parse_batch_id: record.parse_batch_id,
                                source_id: record.source_id,
                                fetcher_response_id: record.fetcher_response_id,
                                error_type: 4
                            })
                        }}>
                            <span className='error-text'>{formatMoney(success_count, 0)} (-{formatMoney(error_count, 0)})</span>
                        </Link> :

                            <Link to={{

                                pathname: `/activity/data-type/${record.data_type_id}/nottransferredtransactions`,
                                search: queryString.stringify({
                                    dateFrom: record.min_txn_date,
                                    dateTo: record.max_txn_date,
                                    parse_batch_id: record.parse_batch_id,
                                    source_id: record.source_id,
                                    fetcher_response_id: record.fetcher_response_id,
                                    success_type: 4
                                })
                            }}>
                                <span className='right-align'>{formatMoney(success_count, 0)}</span>
                            </Link> :
                        <span className='right-align'>{formatMoney(success_count, 0)}</span>
                    }
                </div>,
                props: {
                    className: error_count > 0 ? 'pipeline-error-cell' : 'pipeline-success-cell'
                }
            }
            return obj
        }
    }, {
        title: "Enricher",
        width: 100,
        key: 'Enricher',
        className: 'pipeline-cols center-align',
        render: (record) => {
            let success_count = record.enrichment_success;
            let error_count = record.enrichment_error;
            let obj = {
                children: <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {record.processed == false ?
                        error_count > 0 ? <Link to={{
                            pathname: `/activity/data-type/${record.data_type_id}/nottransferredtransactions`,
                            search: queryString.stringify({
                                dateFrom: record.min_txn_date,
                                dateTo: record.max_txn_date,
                                parse_batch_id: record.parse_batch_id,
                                source_id: record.source_id,
                                fetcher_response_id: record.fetcher_response_id,
                                error_type: 5
                            })
                        }}>
                            <span className='error-text'>{formatMoney(success_count, 0)} (-{formatMoney(error_count, 0)})</span>
                        </Link> :

                            <Link to={{

                                pathname: `/activity/data-type/${record.data_type_id}/nottransferredtransactions`,
                                search: queryString.stringify({
                                    dateFrom: record.min_txn_date,
                                    dateTo: record.max_txn_date,
                                    parse_batch_id: record.parse_batch_id,
                                    source_id: record.source_id,
                                    fetcher_response_id: record.fetcher_response_id,
                                    success_type: 5
                                })
                            }}>
                                <span className='right-align'>{formatMoney(success_count, 0)}</span>
                            </Link> :
                        <span className='right-align'>{formatMoney(success_count, 0)}</span>
                    }
                </div>,
                props: {
                    className: error_count > 0 ? 'pipeline-error-cell' : 'pipeline-success-cell'
                }
            }
            return obj
        }
    },
    {
        title: "TXN COUNT",
        dataIndex: 'txn_count',
        key: 'txn_count',
        className: 'right-align',
        render: (txn_count, data) => {
            let transferred_query = {
                dateFrom: data.min_txn_date,
                dateTo: data.max_txn_date,
                parse_batch_id: data.parse_batch_id,
                fetcher_response_id: data.fetcher_response_id,
                source: data.source_id,
                batched: false
            }
            let untransferred_query = {
                dateFrom: data.min_txn_date,
                dateTo: data.max_txn_date,
                parse_batch_id: data.parse_batch_id,
                source_id: data.source_id,
                fetcher_response_id: data.fetcher_response_id
            }
            return <div style={{
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div><Tooltip
                    arrowPointAtCenter
                    title={<div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end'
                    }}>
                        {data.opening_balance != null && <span>Opening Balance: {data.opening_balance}</span>}
                        {data.closing_balance != null && <span>Closing Balance: {data.closing_balance}</span>}
                        {data.txn_net_amount != null && <span>Net Amount: {data.txn_net_amount}</span>}

                    </div>}>
                    <Link to={{
                        pathname: `/activity/data-type/${data.data_type_id}${data.transferred ? '/transactions' : '/nottransferredtransactions'}`,
                        search: queryString.stringify(data.transferred ? transferred_query : untransferred_query)
                    }}>{formatMoney(txn_count, 0)}</Link></Tooltip>
                </div>
                {data.failed_count != null && <Link to={{
                    pathname: `/activity/data-type/${data.data_type_id}${data.transferred ? '/transactions' : '/nottransferredtransactions'}`,
                    search: queryString.stringify({
                        ...(data.transferred ? transferred_query : untransferred_query),
                        failed: 'true'
                    })

                }}><span className='error-text'>{formatMoney(data.failed_count, 0)} Failed</span></Link>}

            </div>
        }
    },
    {
        title: "Status",
        dataIndex: 'error',
        key: 'status',
        className: 'center-align',
        render: (value, record) => {

            let has_error = (!record.processed || record.error);


            return <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}><div className={has_error ? 'text-tag-danger' : 'text-tag-success'}
                style={{
                    width: 22,
                    height: 22,
                    borderRadius: '50%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {record.processed ?
                        record.error ?
                            <MoreHoriz
                                titleAccess="Processed with error"
                                style={{
                                    width: 12
                                }}
                            />
                            :
                            <CheckOutlined
                                titleAccess="Processed without error"
                                style={{
                                    width: 12
                                }} />
                        : <PriorityHigh
                            titleAccess="Not Processed"
                            style={{
                                width: 12
                            }} />}
                </div></div>
        }
    },
    {
        title: "TRANSFERRED AT",
        dataIndex: 'transferred_at',
        key: 'transferred_at',
    },
    {
        dataIndex: 'id',
        key: 'action',
        width: 40,
        render: (id, record) => {
            return <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}> <MoreOutlined
                    // style={{
                    //     transform: 'rotateZ(180deg)',
                    // }}

                    titleAccess='View Detail'
                    className='basic-icon hand-cursor' onClick={() => {
                        console.log("detail clicked")
                        typeof onViewclicked === 'function' && onViewclicked(id, record)
                    }} />
                <Divider type='vertical' />
                <Link style={{
                    display: 'flex'
                }} to={{
                    pathname: `/activity/data-type/${datatype}/files`,
                    search: queryString.stringify({
                        file_uri: record.file_uri,
                        fetcher_response_id: record.fetcher_response_id,
                        data_selector_id: record.data_selector_id
                    })
                }}>
                    <InsertDriveFileOutlined
                        titleAccess='Go To Files'
                        className='basic-icon hand-cursor'
                    // onClick={() => {
                    //     console.log("detail clicked")
                    //     typeof onViewclicked === 'function' && onViewclicked(id)
                    // }} 
                    /></Link>
            </div>
        }
    }
]
class PacketList extends Component {
    constructor(props) {
        super(props)

        this.datatype = props.match.params.datatype_id;

        this.state = {
            filter_query: {
                per_page: 100,
                page: 1,
                // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                // dateTo: moment().format(defaultDateFormat),
            },
            loading: true,
            datatype_obj: {},
            packet_id: null,
            selected_packet: {}
        }



        this.datatype_detail = RESTExecutor.detail().config({
            label: 'datatypes_details'
        }).callbacks((success) => {
            this.setState({ loading: false, datatype_obj: success.result })
            // overrideHeaderTitle(`${success.result.name} | Files`);
            this.list_packets.forId(this.datatype).config({
                params: {
                    ...this.state.filter_query
                }
            }).execute();
        }, (error) => {
            showErrorInNotification(error);
            this.setState({ loading: false })
        }).forId(this.datatype).connect(props.domains.allData)



        this.list_packets = RESTExecutor.list().config({
            label: 'packet_list'
        }).forId(this.datatype).connect(props.domains.activity);

        this.delay_search = new NetworkDelaySearch();

    }

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {

        const { filter_query, loading, datatype_obj } = this.state;
        if (loading) {
            return <center><Spin /></center>
        }
        let list_packets_resp = this.list_packets.response();
        let datatype_detail_resp = this.datatype_detail.response();

        let list_packets_data = list_packets_resp.result || {};
        let rowsData = list_packets_data.rows || [];
        let rowsMeta = list_packets_resp.meta || {};
        let expression_note = datatype_obj.expression_note || [];


        return (
            <ErrorWrapper
                error={datatype_detail_resp}
                onReload={() => {
                    this.setState({
                        loading: true
                    }, () => {
                        this.datatype_detail.forId(this.datatype).execute()
                    })
                }}
            >
                <Modal
                    visible={this.state.packet_id != null}
                    width="90%"
                    destroyOnClose
                    footer={null}
                    className='transaction-modal'
                    centered
                    onCancel={() => {
                        this.setState({
                            packet_id: null,
                        })
                    }}
                >
                    <ModalPacketDetail
                        isModal={true}
                        onClose={() => {
                            this.setState({
                                packet_id: null,
                            })
                        }}
                        selected_packet={this.state.selected_packet}
                        match={{
                            params: {
                                packet_id: this.state.packet_id
                            }
                        }}
                    />

                </Modal>
                <div>
                    <BasicHeader
                        title={datatype_obj.name}
                        titleType="Datatype"
                        subtitle="Packets"
                        right={[

                            <TransparentButton
                                label="Transfer Detail"
                                icon={<SwapHoriz />}
                                onClick={() => {
                                    this.setState({
                                        view_transfer_detail: !this.state.view_transfer_detail
                                    })
                                }}
                                hint="View Transfer Details"
                            />,
                            <Link to={`/activity/data-type/${this.datatype}/transactions`} >
                                <TransparentButton
                                    label="Transactions"
                                    icon={<StorageOutlined />}
                                    hint="View Transactions"
                                />
                            </Link>,
                            <Link to={`/activity/data-type/${this.datatype}/files`} >
                                <TransparentButton
                                    label="Files"
                                    icon={<InsertDriveFileOutlined />}
                                    hint="View Files"
                                /></Link>,
                            <Link to={`/activity/data-type/${this.datatype}/sources`} >
                                <TransparentButton
                                    label="Sources"
                                    icon={<WifiTetheringOutlined />}
                                    hint="View Sources"
                                />

                            </Link>
                        ]}
                    />
                    {this.state.view_transfer_detail ?
                        <Alert
                            closable

                            onClose={() => {
                                this.setState({
                                    view_transfer_detail: false
                                })
                            }}
                            // message="Transfer Information"
                            style={{
                                marginLeft: 8, marginRight: 8, borderRadius: 10, borderColor: COLORS.primary
                            }}
                            description={<div>
                                <div className='alert-title '>Transfer Expression</div>
                                <div className='alert-subtitle '>{datatype_obj.transfer_expression}</div>

                                {expression_note.length == 0 ? <>
                                    <div style={{
                                        marginTop: 12
                                    }} className='alert-title '>Transfer Information</div>
                                    <ul>
                                        {expression_note.map((exp) => <li className='alert-subtitle '>{exp}</li>)}
                                    </ul>
                                </> : null}
                            </div>}
                            type="info"
                        />
                        : null}
                    <div className='filter-card'>
                        <div style={{
                            display: 'none',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            flexWrap: 'nowrap',
                            paddingTop: 4, paddingBottom: 12
                        }}>
                            {/* <Input.Search
                                placeholder="Input search text"
                                // enterButton
                                allowClear
                                autoFocus
                                value={filter_query.query}
                                style={{}}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault()
                                    this.stateUpdater({
                                        stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {
                                            this.delay_search.onSearch(() => {
                                                this.props.history.push({
                                                    search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                })
                                            })
                                        }
                                    });
                                }}
                            /> */}

                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            // justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            paddingTop: 4, paddingBottom: 4
                        }}>
                            <FilterFixedInput label="Source">
                                <NetworkSelect
                                    value={filter_query.source_id}
                                    style={{ marginRight: 8 }}
                                    item={{ name: "Source", display_key: 'source_id', item_key: "source_id", className: filter_query.source_id != null ? 'filter-option-selected' : '' }}
                                    url={`/my-data-types/${this.datatype}/staging-info/source-labels`}
                                    onChange={(received_value) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query',
                                            valueKey: 'source_id',
                                            value: received_value,
                                            callback: () => {
                                                this.props.history.push({
                                                    search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                })
                                            }
                                        })
                                        // this._change(item.index, received_value, d_key)
                                    }}
                                // renderItem={(data)=>{
                                //     // console.log("data",data)
                                //     let ref = data.__references__ || {};
                                //     let source = ref.source_id || {};
                                //     return source.name
                                //   }}

                                /></FilterFixedInput>

                            <FilterFixedInput label="Transferred">
                                <Select
                                    allowClear
                                    showSearch
                                    className={filter_query.transferred != null ? 'filter-option-selected' : ''}
                                    style={{
                                    }}
                                    placeholder="Yes / No"
                                    value={filter_query.transferred}
                                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={(value, e) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query',
                                            valueKey: 'transferred',
                                            value: value,
                                            callback: () => {
                                                this.props.history.push({
                                                    // pathname:"users",
                                                    search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                })
                                            }
                                        });
                                    }}
                                >
                                    <Select.Option value={'false'}>
                                        Not Transferred
                  </Select.Option>
                                    <Select.Option value={'true'}>
                                        Transferred
                  </Select.Option>
                                    <Select.Option value={'automated'}>
                                        Automated Transferred
                  </Select.Option>
                                    <Select.Option value={'manual'}>
                                        Manual Transferred
                  </Select.Option>
                                    <Select.Option value={'un_trasferred'}>
                                        Un Transferred
                  </Select.Option>
                                </Select>
                            </FilterFixedInput>

                            {/* <FilterFixedInput label="Mode">
                                <Select
                                    allowClear
                                    showSearch
                                    className={filter_query.manual != null ? 'filter-option-selected' : ''}
                                    style={{
                                    }}
                                    placeholder="Manual/Automated"
                                    value={filter_query.manual}
                                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={(value, e) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query',
                                            valueKey: 'manual',
                                            value: value,
                                            callback: () => {
                                                this.props.history.push({
                                                    // pathname:"users",
                                                    search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                })
                                            }
                                        });
                                    }}
                                >
                                    <Select.Option value={'false'}>
                                       Automated
                  </Select.Option>
                                    <Select.Option value={'true'}>
                                        Manual
                  </Select.Option>
                                </Select>
                            </FilterFixedInput> */}

                            <FilterFixedInput label="Date Range">
                                <CustomDateRangePicker
                                    style={{
                                        // width: 400,
                                        // marginLeft: 16,
                                        flex: null
                                    }}
                                    startDate={filter_query.dateFrom ? moment(filter_query.dateFrom, defaultDateFormat) : null}
                                    endDate={filter_query.dateTo ? moment(filter_query.dateTo, defaultDateFormat) : null}
                                    onChange={(dates) => {
                                        //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                                        this.stateUpdater({
                                            stateKey: 'filter_query', appendObj: {
                                                dateFrom: dates.startDate.format(defaultDateFormat),
                                                dateTo: dates.endDate.format(defaultDateFormat), page: 1
                                            },
                                            callback: () => {
                                                this.props.history.push({
                                                    search: queryString.stringify(this.state.filter_query)
                                                })
                                            }
                                        })
                                    }}

                                />
                            </FilterFixedInput>
                        </div>
                    </div>
                    <ExternalFilterClear
                        filters={filter_query}
                        staticKeys={['dateFrom', 'dateTo', 'transferreds', 'source_id']}
                        onClear={(new_filters) => {
                            this.props.history.push({
                                search: queryString.stringify(new_filters)
                            })
                        }}
                    />
                    <ErrorWrapper
                        error={list_packets_resp}
                        onReload={() => {
                            this.list_packets.execute()
                        }}
                    >
                        <div className='default-card' style={{
                            // margin:0
                        }}>
                            <Table
                                loading={list_packets_resp.fetching}
                                dataSource={rowsData}
                                className='main-table'
                                size='small'
                                columns={packets_cols({
                                    datatype: this.datatype,
                                    filters: {
                                        dateFrom: filter_query.dateFrom,
                                        dateTo: filter_query.dateTo,
                                        transferred: filter_query.transferred,
                                        fetcher_response_id: filter_query.fetcher_response_id
                                    },
                                    onViewclicked: (id, data) => {
                                        this.setState({
                                            packet_id: id,
                                            selected_packet: data
                                        })
                                    },
                                    onFilterUpdate: (data = {}) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query',
                                            appendObj: data,
                                            callback: () => {
                                                this.props.history.push({
                                                    search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                                                })
                                            }
                                        })
                                    }
                                })}
                                pagination={{
                                    simple: false,
                                    size: 'small',
                                    position: 'bottom',
                                    onChange: (current, size) => {
                                        this.props.history.push({
                                            search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                        })
                                    },
                                    defaultCurrent: 1,
                                    current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                    pageSize: (rowsMeta && rowsMeta.requested_count),
                                    total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
                                    showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count, 0)} items`
                                }}
                            />
                        </div>
                    </ErrorWrapper>
                </div>
            </ErrorWrapper >

        )
    }

    componentDidMount() {

        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                // dateTo: moment().format(defaultDateFormat),
                ...new_filter_query
            }
        }, () => {
            this.datatype_detail.execute()
            // this.list_packets.config({
            //     params: {
            //     ...this.state.filter_query
            //     }
            // }).execute()
        })

    }

    componentWillReceiveProps(nextProps) {
        var olddatatype_id = this.props.match.params.datatype_id;
        var newdatatype_id = nextProps.match.params.datatype_id;




        if (olddatatype_id !== newdatatype_id || (
            this.props.location && (this.props.location.search !== nextProps.location.search)
        )) {
            this.datatype = newdatatype_id;
            const parsed = queryString.parse(nextProps.location.search);
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                    // dateTo: moment().format(defaultDateFormat),
                    ...parsed
                },
            }, () => {
                if (olddatatype_id !== newdatatype_id) {
                    this.setState({
                        loading: true
                    }, () => {
                        this.datatype_detail.forId(this.datatype).execute()
                    })
                } else {
                    this.list_packets.forId(this.datatype).config({
                        params: {
                            ...this.state.filter_query
                        }
                    }).execute()
                }



            })

        }
    }


}

export default withDomains(PacketList, "activity", "allData")
